module.exports = __webpack_public_path__ + "static/media/report-selected.abe25448.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/report-selected.svg
// module id = 253
// module chunks = 0